import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/unassigned/delete`;

export const ROUTE: RouteDefinition = `${baseRoute}/unassigned/delete`;

export const URL = (): RouteDefinition => `${baseRoute}/unassigned/delete`;
